



































































































































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import CountrySelect from "../../components/fiat_trade/CountrySelect.vue";
import { setAddress, defaultAddress } from "../../views/fiat/wyre.vue";

@Component({
  components: {
    CountrySelect
  }
})
class BillAddress extends Vue {
  @Prop() supportCountries;

  @PropSync("address") bindAddress;

  dialog = false;

  get meta() {
    const {
      firstName,
      lastName,
      street,
      state,
      country,
      city,
      postalCode,
      email,
      phone
    } = this.bindAddress;
    let needFill = false;
    if (
      !firstName ||
      !lastName ||
      !street ||
      !state ||
      !country ||
      !city ||
      !postalCode ||
      !email ||
      !phone
    ) {
      needFill = true;
    }
    const hasName = firstName || lastName;
    const hasAddress = street || state;
    return {
      needFill,
      hasName,
      country: country,
      name: hasName ? `${firstName} ${lastName}` : "",
      label: hasAddress ? `${street} ${state}` : "-"
    };
  }

  handleSave() {
    setAddress(this.bindAddress);
    this.dialog = false;
  }

  handleClear() {
    setAddress(defaultAddress);
    this.bindAddress = defaultAddress;
    this.dialog = false;
  }
}
export default BillAddress;
